import React from 'react';
import { useParams } from 'react-router-dom';

import BoxContainer from '../../../style-components/BoxContainer.jsx';
import HeaderContainer from '../../../style-components/HeaderContainer.jsx';
import ResourcesList from './components/ResourcesList.jsx';

import { resourcesConfig } from '../resourcesConfig.js';

const ResourcesListWrapper = () => {
  const params = useParams();
  const resourceType = params.resourceType;
  const rest = params['*'] || '';
  const pathSegments = rest.split('/').filter(Boolean);

  const config = resourcesConfig[resourceType];
  const label = config?.label || 'Recursos';

  return (
    <BoxContainer>
      <div className='antialiased font-sans w-full'>
        <div className='divide-y divide-primary'>
          <HeaderContainer title={label} />
          <div className='py-8 px-4 sm:px-8 min-w-full w-full'>
            <ResourcesList resourceType={resourceType} pathSegments={pathSegments} showBackButton />
          </div>
        </div>
      </div>
    </BoxContainer>
  );
};

export default ResourcesListWrapper;
